import { render, staticRenderFns } from "./trainingVister.vue?vue&type=template&id=523ae5cf&"
import script from "./trainingVister.vue?vue&type=script&lang=js&"
export * from "./trainingVister.vue?vue&type=script&lang=js&"
import style0 from "./trainingVister.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports